// removed by extract-text-webpack-plugin
module.exports = {"global":"\"../../globals.css\"","small":"767px"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/App/App.css
// module id = 759
// module chunks = 0